import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { HiOutlineArrowLeft, HiOutlineCalendar, HiOutlineTag } from 'react-icons/hi2';
import { usePortfolioById } from '../hooks/useApi';
import Footer from '../components/Footer';

function PortfolioPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data, loading, error } = usePortfolioById(id);

  const project = data?.data || data;

  if (loading) {
    return (
      <main>
        <div className="portfolio-detail" style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div className="spinner" />
        </div>
        <Footer />
      </main>
    );
  }

  if (error || !project) {
    return (
      <main>
        <div className="portfolio-detail">
          <div className="container" style={{ textAlign: 'center', paddingTop: 120 }}>
            <h2 style={{ marginBottom: 16 }}>Project Not Found</h2>
            <p style={{ color: '#777', marginBottom: 32 }}>
              {error || 'The project you are looking for does not exist or has been removed.'}
            </p>
            <button className="btn btn--primary" onClick={() => navigate('/')}>
              Back to Home
            </button>
          </div>
        </div>
        <Footer />
      </main>
    );
  }

  const images = project.images || project.gallery || [];
  const heroImage = project.thumbnail || project.image || images[0] || null;

  return (
    <main>
      <motion.div
        className="portfolio-detail"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className="container">
          <button className="portfolio-detail__back" onClick={() => navigate('/')}>
            <HiOutlineArrowLeft /> Back to Portfolio
          </button>

          {/* Hero Image */}
          {heroImage ? (
            <img
              className="portfolio-detail__hero-img"
              src={heroImage}
              alt={project.title}
            />
          ) : (
            <div
              className="portfolio-detail__hero-img"
              style={{
                background: 'linear-gradient(135deg, #1a2a2a, #0f3a36)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '1.2rem',
                color: '#555',
              }}
            >
              {project.title}
            </div>
          )}

          {/* Title & Meta */}
          <h1 className="portfolio-detail__title">{project.title}</h1>

          <div className="portfolio-detail__meta">
            {project.category && (
              <span className="portfolio-detail__meta-item">
                <HiOutlineTag style={{ verticalAlign: 'middle', marginRight: 6 }} />
                <span>{project.category}</span>
              </span>
            )}
            {project.year && (
              <span className="portfolio-detail__meta-item">
                <HiOutlineCalendar style={{ verticalAlign: 'middle', marginRight: 6 }} />
                <span>{project.year}</span>
              </span>
            )}
            {project.client && (
              <span className="portfolio-detail__meta-item">
                Client: <span>{project.client}</span>
              </span>
            )}
          </div>

          {/* Description */}
          <div className="portfolio-detail__body">
            {project.full_description || project.description || 'No description available.'}
          </div>

          {/* Image Gallery */}
          {images.length > 0 && (
            <div className="portfolio-detail__gallery">
              {images.map((img, idx) => (
                <img key={idx} src={img} alt={`${project.title} - ${idx + 1}`} loading="lazy" />
              ))}
            </div>
          )}

          {/* Back button */}
          <div style={{ textAlign: 'center', paddingTop: 20, paddingBottom: 40 }}>
            <button className="btn btn--outline" onClick={() => navigate('/')}>
              View All Projects
            </button>
          </div>
        </div>
      </motion.div>
      <Footer />
    </main>
  );
}

export default PortfolioPage;
